import { useState , useEffect } from 'react';
import VoteCard from './voteCard';
import VoteConfModal from './voteConfModal';
let votes = require('../seeders/seedVotes.json');
let meetings = require('../seeders/seedMeetings.json');
let events = require('../seeders/seedEvents.json');
let event

// let meeting = JSON.parse(window.localStorage.getItem('meeting'))
// let vote = JSON.parse(window.localStorage.getItem('vote'))
// if(!vote){
//     console.log("no vote?")
//     if(!event){
//         console.log("no event?...Default")
//         event = events[0]
//         vote = votes[0]
//         console.log("[Vote] vote: ",vote)
//     }
// }

// function getCardInfo(){
    //     const PORT=3000
    //     const MONGO_URI="mongodb://localhost:27017/votes"
    //  }
    let i = 0
    function Vote(props) {
    const vote = props.vote
    const { _id, title, space, type, descr, options, meeting_id, voters, status,time_handling, end}  = vote
    const [ confirmToggle , setConfirmToggle ] = useState(false)
    const [showDuration , setShowDuration] = useState(false)
    const [showAdmin , setShowAdmin] = useState(false)
    const [time, setTimer] = useState('')
    const [ curOption  , setCurOption ] = useState('')
    let time_class = `${time_handling} blink-slower`
    let status_class = `${status} status blink-faster`
    const meeting = JSON.parse(window.localStorage.getItem('meeting'))
    let local_togg
    let vote_pair

    useEffect(()=>{
        vote_pair = JSON.parse(localStorage.getItem('TH_vote_pair'))
        local_togg = JSON.parse(localStorage.getItem('TH_vote_submit'))
        // if(!vote_pair){setConfirmToggle(false)}
        // else if((!vote_pair ) && (local_togg)){setConfirmToggle(true)}
        
        // if(!vote_pair){setConfirmToggle(false)}
        // else if((!vote_pair ) && (local_togg)){setConfirmToggle(true)}
    },[])
    function getOptByTitle(option){
        // console.log(`getOptByTitle${i}: `,option)
        // return option.title == curOption
        i++
        return Object.keys(option).find(key => option[key] == curOption);
    }
    let cur_opt_obj ={}= options.filter(getOptByTitle); 
    let opt = cur_opt_obj[0]
    console.log("cur_opt_obj",opt)
 function generateOptions(){
   let option_map = options.map((option,index) => {
      return (<button className="vote-options" 
        value={option.title} 
        key={index} 
        onClick={(e)=>handleVoteClick(e)}>
        {option.title}</button>)
    })
//    console.log(option_map)
        return option_map   
    }
    function generateTopPics(){
        console.log('generate top picks')
        let option_map = options.map((option,index) => {
            return (<button className="vote-options" id="top_picks_opt" value={option.title} key={index} onClick={(e)=>handleVoteClick(e)}><span className="down-vote-arw blink">&#x21D3;</span>&nbsp;{option.title}&nbsp;<span className="up-vote-arw blink">&#x21D1;</span></button>)
            })
            //    console.log(option_map)
            return option_map   
        }
        
    function generateVote(){
            console.log("[generateVote]type: ", type)
            if(type ==='top_picks'){
            return  generateTopPics()
            }else{return generateOptions()}
        }
    function submitVote(e){
            e.preventDefault()
            // if(!){
                localStorage.setItem('TH_vote_pair', JSON.stringify([_id,curOption]))
                localStorage.setItem('TH_vote_sumbit', true)
                setConfirmToggle(true)
                console.log("[submitVote]: curOption", curOption)
            // }
        }


   

    function handleVoteClick(e){
        let cur_option = [] = e.target.value
        let targ_id = e.target.id
    //    let i = e.target.key
    //     console.log('e.target.key',e.target.key)
        console.log("VoteClick: ", options.title  ==  cur_option)
        console.log("VoteClick targ_id: ", targ_id)
        setCurOption(cur_option)
        localStorage.setItem('TH_vote_pair',JSON.stringify([_id,curOption]))
        localStorage.setItem('TH_vote_submit',false)
        console.log("Local vote_pair: ",JSON.parse(localStorage.getItem('TH_vote_pair')))
    }


    // console.log(vote)
    function timer(){
        var countDownDate = new Date(end).getTime();
        // Update the count down every 1 second
        var x = setInterval(function() {
        // Get today's date and time
        var now = new Date().getTime();
        // Find the distance between now and the count down date
        var distance = countDownDate - now;
        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        // Display the result in the element with id="demo"
        setTimer(`${days}d ${hours}h ${minutes}m ${seconds}s`)
        // If the count down is finished, write some text
        if (distance < 0) {
            clearInterval(x);
            setTimer(`expired`)
        }
        }, 1000);
            }

     if (showDuration){timer()}
 
  
    return (
        <section className="vote-container center">   

            <div className="vote-header" id="header">
                <div className="vote-header-left">
                   <span className={status_class}><span id="meeting_status"> &#x2022; {status} </span></span>
                </div>
                <div className="vote-header-center">
                    
                    <span>
                       {!showDuration&&(
                        <span className={time_class} id="vote_time_handling" 
                            onClick={() => 
                            setShowDuration(true)}>
                            &#9663; {time_handling}-time 
                        </span> )}
                        {showDuration&&( 
                            <span className= {time_class} id="vote_time_handling"
                            onClick={() => setShowDuration(false)}
                            >&#9657; {time}</span>)} 
                    </span> 
                    {/* <br/> */}
                    <div>
                        {meeting.meeting_title}
                    </div>
                    <span className="blink-slower">"{title}"</span>
                    
                    

                </div>
                <div className="vote-header-right">
                   <span className={space}>{space}</span>
                </div>
            </div>
            <h4 className="color-grad-blue-text">{type}</h4>
            <div className="vote-body-warp">
            
            <section className="vote-body">
                <div className="option-box-wrap ">
                    <div className="option-box center">
                        {vote && generateVote()}
                    </div>
                </div>
            </section>
          {curOption && ( <section className='vote-selection-wrap'> 
                    <div className='vote-selection-frame'>
                
                       <h3>{curOption}</h3>
                       <div>
                            <strong>description:</strong><p className="opt-descr">
                            {opt.info}
                            </p>
                       </div>
                       <br/>
                       <div>
                            <strong>potential pros:</strong><p className="opt-pros">
                                {opt.pros}
                                </p>
                       </div>
                       <br/>
                       <div>
                            <strong>potential cons:</strong><p className="opt-cons">
                                {opt.cons}
                                </p>
                       </div>
                       <br/>
                    </div>      
                        <button className="vote-submit-btn blink" onClick={submitVote}>submit</button>
            </section>)}

            {confirmToggle && (
                <VoteConfModal option={curOption} view={props.view}/>
             )}  
            </div>
        </section>
  );
}
export default Vote; 